// extracted by mini-css-extract-plugin
export default {"page":"Menu_page__TzV8J","menu_container":"Menu_menu_container__m6Ug4","menu":"Menu_menu__hMm5T","header":"Menu_header__Mv38I"};